import { combineReducers } from 'redux';

import roundPlayReducer from './reducers/roundPlayReducer';
import screenReducer from './reducers/screenReducer';
import sessionReducer from './reducers/sessionReducer';
import particlesReducer from './reducers/particlesReducer';
import savedDataReducer from './reducers/savedDataReducer';
// keeping the reducer collection as a separate exported object enables us
// to do some light test automation on every reducer.
// see ./reducers/__tests__/reducerRejections.test.js
// for more details.
export const reducerCollection = {
  screen: screenReducer,
  roundPlay: roundPlayReducer,
  session: sessionReducer,
  particles: particlesReducer,
  savedData: savedDataReducer,
};

const reducers = combineReducers({ ...reducerCollection });

export default reducers;
